import { render, staticRenderFns } from "./TestOrdersResultSetupListing.vue?vue&type=template&id=cca12320&"
import script from "./TestOrdersResultSetupListing.vue?vue&type=script&lang=js&"
export * from "./TestOrdersResultSetupListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports